import { useContext } from 'react';
import { Context } from '../../StoreContext/Context';
import './BannerParallax.css';

const BannerParallax = () => {
  const { info } = useContext(Context);
    return(
        <>
        {/* parallax section */}
        <div className="dalk-image">
        <img
            className="desktop-image"
            src='https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fmtm%2FBanner%20libbs%201920x1080%20(2).png?alt=media&token=b56d0174-e788-487f-9a3e-1f0bb29d5ef1'
            alt="Imagem Banner"
        />
        </div>
        {/* section close */}
        </>
    );
}

export default BannerParallax;
